import { formatTaskDate } from '../../../../utils/taskDate';

// ---------------------------------------------------------------------------
// Status chip formatter
// ---------------------------------------------------------------------------
export const statusColors = {
  Draft: '#9e9e9e',
  Assigned: '#2196f3',
  Pending: '#f44336',
  'Submitted for Approval': '#9c27b0',
  Complete: '#4caf50',
  'On Hold': '#795548',
  Cancelled: '#607d8b'
};

// ---------------------------------------------------------------------------
// Priority chip formatter
// ---------------------------------------------------------------------------
export const priorityColors = {
  Critical: '#d32f2f',
  High: '#f57c00',
  Normal: '#1976d2',
  Low: '#757575'
};

export const formatDateDDMMYYYY = formatTaskDate;

const formatEmployeeAuditValue = (value, employees = [], emptyLabel) => {
  const assignments = Array.isArray(value) ? value : value ? [value] : [];
  const names = assignments
    .map((assignment) => {
      const employee = assignment?.employeeId || assignment;
      const employeeId = employee?._id || employee?.Id || employee;
      const populatedName =
        employee?.DisplayName || employee?.FirstName || employee?.GivenName || employee?.preferredName;
      if (populatedName) return populatedName;

      const matchingEmployee = employees.find((option) => String(option._id || option.Id) === String(employeeId || ''));
      return (
        matchingEmployee?.DisplayName ||
        [matchingEmployee?.FirstName, matchingEmployee?.LastName || matchingEmployee?.FamilyName]
          .filter(Boolean)
          .join(' ') ||
        'Unknown employee'
      );
    })
    .filter(Boolean);

  return names.length ? names.join(', ') : emptyLabel;
};

export const formatAuditValue = (action, value, employees = [], taskOptions = []) => {
  if (action === 'Assignee changed') {
    return formatEmployeeAuditValue(value, employees, 'None');
  }

  if (action === 'Supporting staff changed') {
    return formatEmployeeAuditValue(value, employees, 'None');
  }

  if (action === 'Dependencies changed') {
    const dependencies = Array.isArray(value) ? value : value ? [value] : [];
    if (!dependencies.length) return 'None';

    return dependencies
      .map((dependency) => {
        if (dependency?.title) return dependency.title;
        const dependencyId = dependency?._id || dependency;
        const matchingTask = taskOptions.find(
          (option) => String(option?.value || option?._id || option?.id) === String(dependencyId)
        );
        return matchingTask?.label || matchingTask?.title || 'Unknown task';
      })
      .join(', ');
  }

  if (action === 'Due date changed') {
    return formatDateDDMMYYYY(value);
  }

  if (value === undefined || value === null || value === '') return '—';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const getDisplayName = (changedBy, employees = []) => {
  if (!changedBy) return '';

  // Audit entries returned immediately after an update can contain a populated
  // employee object, while entries loaded later can contain only its ID.
  if (typeof changedBy === 'object') {
    const populatedName =
      changedBy.DisplayName ||
      [changedBy.FirstName, changedBy.LastName || changedBy.FamilyName].filter(Boolean).join(' ');
    if (populatedName) return populatedName;
  }

  const changedById = changedBy?._id || changedBy?.Id || changedBy;
  const matchedEmployee = (Array.isArray(employees) ? employees : []).find(
    (employee) => String(employee?._id || employee?.Id) === String(changedById)
  );

  return (
    matchedEmployee?.DisplayName ||
    [matchedEmployee?.FirstName, matchedEmployee?.LastName || matchedEmployee?.FamilyName].filter(Boolean).join(' ')
  );
};
